import { useMutation } from '@tanstack/react-query';

import { apiPost } from '../../lib/api.js';

export type SendKind = 'overview' | 'checklist';

export interface SendPayload {
  courseId: string;
  recipientEmail: string;
  recipientName?: string;
  subjectOverride?: string;
  bodyOverride?: string;
  ccEmails?: string[];
}

export interface SendResponse {
  ok: true;
  id: string;
  messageId: string;
}

/**
 * Calls POST /api/v1/send/overview or /api/v1/send/checklist depending on kind.
 *
 * Returns standard TanStack Query mutation states.
 */
export function useSend(kind: SendKind) {
  return useMutation<SendResponse, Error, SendPayload>({
    mutationFn: async (payload) => {
      const cleaned: SendPayload = {
        courseId: payload.courseId,
        recipientEmail: payload.recipientEmail.trim(),
      };
      if (payload.recipientName && payload.recipientName.trim().length > 0) {
        cleaned.recipientName = payload.recipientName.trim();
      }
      if (payload.subjectOverride && payload.subjectOverride.trim().length > 0) {
        cleaned.subjectOverride = payload.subjectOverride.trim();
      }
      if (payload.bodyOverride && payload.bodyOverride.trim().length > 0) {
        cleaned.bodyOverride = payload.bodyOverride.trim();
      }
      if (payload.ccEmails && payload.ccEmails.length > 0) {
        cleaned.ccEmails = payload.ccEmails.map((e) => e.trim()).filter((e) => e.length > 0);
      }
      const path = kind === 'overview' ? '/send/overview' : '/send/checklist';
      return apiPost<SendResponse>(path, cleaned);
    },
  });
}
